





















import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import { ApiGeneralObjectArrayPayload, ApiGeneralSinglePayload } from '@/tcw/api/types'
import BaseComponent from '@/tcw/components/BaseComponent'
import TcwGetsudoPicker from '@/components/common/TcwGetsudoPicker.vue'
import KintaiAction from '@/components/kintai/molecules/KintaiAction.vue'
import ShouninStatus from '@/components/kintai/molecules/ShouninStatus.vue'
import { KintaiActionMenu } from '@/components/kintai/types'
import { TcwFormDate } from '@/tcw/domain/types'
import Getsudo from '@/tcw/domain/Getsudo'

@Component({
  components: { TcwGetsudoPicker, KintaiAction, ShouninStatus }
})
export default class ShouninKintaiLocalHeader extends Mixins(BaseComponent) {
  @Prop({
    default: () => {
      /** */
    }
  })
  protected teishutsu!: ApiGeneralSinglePayload
  @Prop({
    default: () => {
      /** */
    }
  })
  protected user!: ApiGeneralSinglePayload
  @Prop({ type: Getsudo, default: null })
  private getsudo!: Getsudo | null
  @Prop({ default: () => [] })
  private actions!: KintaiActionMenu[]
  @Prop({ type: Boolean, default: () => false })
  private processingAction!: boolean

  get getsudoDate(): TcwFormDate {
    if (!this.getsudo) 
      return null
    // dateOf関数に正式な日付(例:2026/4/1)を渡すためdayに'1'を付与する
    // 2026/4のみだとブラウザにInvalidDateと表示される。
    return this.tcw.dateOf(this.getsudo.yearValue + '/' + this.getsudo.monthValue + '/1')
  }
  get getsudoStr(): string {
    return this.du.convertDateToStr(this.getsudoDate, 'YYYY年MM月度')
  }
  get shouninUserList(): ApiGeneralObjectArrayPayload {
    return Array.isArray(this.teishutsu?.shouninUserList)
      ? (this.teishutsu.shouninUserList as ApiGeneralObjectArrayPayload)
      : []
  }
  get hasBall(): boolean {
    return this.shouninUserList.some(user => user.id === this.loginUserId)
  }

  @Emit()
  private selectAction(command: string) {
    console.log(command)
  }
}
